'use client';

import { LocalizationProvider } from '@hrworks/localization';

import type { LocalizationBoundaryProps } from './LocalizationBoundary.types';

/**
 * Setzt die Sprache fuer die Texte, die aus dem Dictionary von `@hrworks/localization` kommen –
 * etwa die Validierungsmeldungen des DateFields.
 *
 * Hintergrund: `SuiNextJsProvider` rendert intern einen `LocalizationProvider`, reicht aber nur
 * `dictionary` weiter – ein `locale` landet in den Props des SuiThemeProviders und verpufft.
 * Ohne Locale faellt der Provider auf `de` zurueck, wodurch sui-core-Texte auch auf der
 * englischen Seite deutsch bleiben, waehrend die stellenportal-eigenen Texte ueber next-intl
 * korrekt uebersetzt sind.
 *
 * Dieser Provider steht oberhalb des SuiNextJsProviders. Dessen innerer LocalizationProvider
 * erbt die Sprache dann ueber den Context (`locale || localeFromContext || 'de'`).
 *
 * Vorerst bewusst nur im Stellenportal. Die eigentliche Behebung gehoert in den SuiProvider.
 */
export const LocalizationBoundary = ({ locale, children }: LocalizationBoundaryProps) => (
  <LocalizationProvider locale={locale}>{children}</LocalizationProvider>
);
